import * as EventManager from "../events/event-manager.js";

/**
 * Service Provider Referral
 */
export const SPReferral = (function () {

    let csrf;
    let referralID;
    let rejectButton;
    let acceptButton;
    let inviteButton;
    let client=[];
    let eventManager;

    let init =  function () {

        //set shared variables
        csrf = Util.getCSRF();
        referralID = window.location.href.split('/').pop();
        rejectButton = $("#myds-referral-reject");
        acceptButton = $("#myds-referral-accept");
        inviteButton = $("#myds-referral-invite");
        client['client-name'] = $("#myds-referral-referee_name-value").html();
        client['mydexid'] = $("#myds-referral-referee_name-value").data('mydexid');
        eventManager = EventManager.EventManager("SP", SPReferral);

        /////Add event listeners/////
        eventManager.addEventListeners();

        acceptButton.on('click', function(e) {
            e.preventDefault();
            manageReferral('Accepted');
            
        });

        rejectButton.on('click', function(e) {
            e.preventDefault();
            manageReferral('Rejected');
        });

        inviteButton.on('click', function(e) {
            e.preventDefault();
            eventManager.showAddEventModal(null, client);
        });
  
    }

    /**
     * manages click event to accept or reject a referral
     */  
    let manageReferral = function(status) {
        updateReferralStatusRequest(status).done(function(response) {

            if (response == "Permission denied") {
                Util.toggleAlert('#myds-alert-referral', 'You do not have permission to do that.', 'alert-warning');
            } else {
                $("#myds-status-image").attr('src', response['icon_path']);
                statusChangeUpdatesUI(status);
            }

        }).fail(function(err) {
            Util.toggleAlert('#myds-alert-referral', 'there was a problem updating this referral, please try again', 'alert-warning');
        })
    }

    /**
     * handles requests to back end to update referral status.
     * returns file path for icon to be updated in UI
     */
    let updateReferralStatusRequest = function(status) {
        
        return $.ajax({
            headers: {
            'x-csrf-token': csrf
            },
            url: '/clients/referral-status-update/' + referralID,
            type: 'post',
            data: {
                'status' : status
            }
        });
    }

    /**
     * @param status string  
     * removes accept / reject button and replaces with relevant content
     */
    let statusChangeUpdatesUI = function(status) {
        
        rejectButton.addClass('d-none');
        acceptButton.addClass('d-none');

        Util.toggleAlert('#myds-alert-referral', "Referral " + status, 'alert-success', 8000);
        $('#myds-referral-referral_status-value').html(status);

        if (status == 'Accepted') {
            $('#myds-referral-invite').removeClass('d-none');
            $('#myds-referral-rejected-message').addClass('d-none');
        }

    }

    ////////Functions required for use of Events module//////////

    /**
     * Defines how events are to be handled in this context for use in Events module
     */
    let eventHandlers = {
        saveEvent : function() {
            Util.toggleAlert('#myds-alert-referral', "Your client has been invited to this appointment", 'alert-success', 8000);
        }
    }
    /**
     * gets mydexid so that they can be invited to an event (required for use of Events module)
     */
    let getInviteeList = function() {
        return [
            {
                'mydexid' : client['mydexid'],
                'invitee_name' : client['client-name']
            }
        ];
    }
    //event manager uses this to link events to this context i.e. the referral
    let getReferralID = function() {
        return $('#referral-id').data('referral');
    }

    return {
      init : init,
      eventHandlers : eventHandlers,
      context : "Referral",
      getContextID : getReferralID,
      getInviteeList : getInviteeList
    }
  
}());


  